function initListener() {
  document.body.addEventListener('error', e => {
    console.log(e)
    pic.setAttribute('goterror', 'true')
    console.log()
  })
  const picsNotWathingError = document.querySelectorAll(
    'img:not([watchimageerror])',
  )
  picsNotWathingError.forEach(pic => {
    pic.addEventListener('error', () => {
      pic.setAttribute('goterror', 'true')
      console.log()
    })
    pic.setAttribute('watchimageerror', 'false')
    pic.setAttribute('onerror', 'this.style.opacity = 0')
  })
  console.log('init picture error listener')
}
try {
  setTimeout(() => {
    initListener()
  }, 5000)
} catch (error) {
  console.log(error)
}
